import { Tooltip } from '@heroui/react'
import PropTypes from 'prop-types'

const SimpleIconList = ({ classNames = {}, iconSize="md", items, showBorder = true, textColor = null }) => {
  const iconSizeClasses = {
    sm: "w-4 h-4",
    md: "w-8 h-8",
    lg: "w-10 h-10",
  }

  return (
    <ul className={classNames?.container || ""}>
      {items.map((item, index) => (
        <li key={index} className={`flex ${textColor ? textColor : 'text-content2-foreground'} items-center ${showBorder ? 'py-2 pb-2 border-dotted [&:not(:last-child)]:border-b-1' : ''}`}>
          <div className='flex items-center'>
            <Tooltip 
              classNames={{ content: "bg-indigo-800 text-white" }} 
              content={item.description || null} 
              key={index} 
              isDisabled={!item?.description}
              placement='right' 
            >
              <div className={`${iconSizeClasses[iconSize]} mr-4`}>
                {item.icon}
              </div>
            </Tooltip>
            
            <p className={`${iconSize === 'sm' ? 'text-sm' : 'text-base'}`}>
              {item.caption}
            </p>
          </div>
        </li>
      ))}
    </ul>
  )
}

SimpleIconList.propTypes = {
  classNames: PropTypes.shape({
    container: PropTypes.string,
  }),
  items: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.node,
      caption: PropTypes.string,
      description: PropTypes.string,
    })
  ).isRequired,
  showBorder: PropTypes.bool,
  textColor: PropTypes.string,
}

export default SimpleIconList